package org.zest.insan_360_website.pages.user

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.dashboard.CreditsDashboardState.fetchCreditStatistics
import org.zest.insan_360_website.data.page_states.dashboard.CreditsDashboardState.fetchSupAdmPaymentsList
import org.zest.insan_360_website.components.widgets.RoleGate
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.pages.user.credits_layout.AdminLayout
import org.zest.insan_360_website.pages.user.credits_layout.SuperAdminLayout

@Page
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun CreditsPage(ctx: PageContext) {
    val scope = rememberCoroutineScope()
    RoleGate(UserRole.ADMIN, UserRole.SUPER_ADMIN, ctx = ctx) {
        LaunchedEffect(Unit) {
            if (AuthState.role == UserRole.ADMIN) fetchCreditStatistics(scope)
            if (AuthState.role == UserRole.SUPER_ADMIN) fetchSupAdmPaymentsList(scope)
        }
        if (AuthState.role == UserRole.ADMIN) AdminLayout()
        if (AuthState.role == UserRole.SUPER_ADMIN) SuperAdminLayout()
    }
}